// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"c3a99a48","293":"b679aecf","763":"6b19f999","854":"51547d1d","949":"a47699e0","993":"63b18f7c"}[chunkId] + ".chunk.js";
};